import React from 'react'
import useIncompleteSurvey from './use-incomplete-survey'
import SurveyForm from '../survey'
import useSurveyMutation from './use-survey-mutation'
import HourLabel from '../../hours/label'
import DurationLabel from '../../durations/label'
import moment from 'moment'
import BusyModal from '../../modals/busy'

const UserFacilitatorSurvey = ({
    children
}) => {
    const { hasSurveys, dismiss, facilitatorSurvey } = useIncompleteSurvey()
    const survey = facilitatorSurvey || {}
    const {
        rating,
        setRating,
        feedback,
        setFeedback,
        submitSurvey,
        isSubmittingSurvey
    } = useSurveyMutation({ surveyId: survey.id, onSuccess: dismiss })

    if (isSubmittingSurvey) {
        return (
            <BusyModal title="Submitting Survey..." />
        )
    }

    if (hasSurveys) {
        return (
            <SurveyForm
                onConfirm={() => submitSurvey()}
                onCancel={() => dismiss()}
                title = 'Rate This Facilitator:'
                rating={rating}
                onRatingChange={setRating}
                feedback={feedback}
                onFeedbackChange={setFeedback}
            >
                <div style={{ textAlign: 'center' }}>
                    <div><h3>{survey.firstName} {survey.lastName}</h3></div>
                    <div>{survey.name}</div>
                    <div>{moment(survey.date).format('dddd, MMMM Do YYYY')}</div>
                    <HourLabel hourId={survey.hourId}/> <DurationLabel durationId={survey.durationId} />
                </div>
            </SurveyForm>
        )
    }

    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    )
}

export default UserFacilitatorSurvey
